import { render, staticRenderFns } from "./mapTag.vue?vue&type=template&id=6bfd1b5f&scoped=true&"
import script from "./mapTag.vue?vue&type=script&lang=js&"
export * from "./mapTag.vue?vue&type=script&lang=js&"
import style0 from "./mapTag.vue?vue&type=style&index=0&id=6bfd1b5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfd1b5f",
  null
  
)

export default component.exports